import React from "react";
import { COLORS } from "@fanduel/formation-theming";
import { Flex, FlexProps } from "@fanduel/formation-react-components";

const ModalOverlay = ({ children, ...rest }: FlexProps) => (
  <Flex
    align="center"
    bg={COLORS.coreBlackTint070}
    justify="center"
    position="fixed"
    top={0}
    left={0}
    right={0}
    bottom={0}
    zIndex={999}
    {...rest}
  >
    {children}
  </Flex>
);
ModalOverlay.displayName = "Alert.Overlay";

export default ModalOverlay;
